/**
 * The API is served by the same worker as this app, so the hosted app's
 * NEXT_PUBLIC_BACKEND_URL collapses to the page's own origin.
 */
export const BACKEND = ""
